import PaymentLayoutComponent from '@/components/layouts/payment-layout/payment-layout.component';
import {RouteConfig} from 'vue-router';
import CheckoutComponent from './checkout/checkout.component';
import PaymentFailComponent from './checkout/payment-fail.component';
import PaymentSuccessComponent from './checkout/payment-success.component';
import SubscriptionPlanComponent from './subscription-plan/subscription-plan.component';

export const PaymentRoutes: Array<RouteConfig> = [
    {
        path: '/payment',
        name: 'Payment',
        component: PaymentLayoutComponent,
        redirect: {name: 'Payment'},
        children: [
            {
                path: 'checkout',
                name: 'Checkout',
                component: CheckoutComponent,
            },
            {
                path: 'subscription-plan',
                name: 'SubscriptionPlan',
                component: SubscriptionPlanComponent,
            },
            {
                path: 'success',
                name: 'Payment Success',
                component: PaymentSuccessComponent,
            },
            {
                path: 'fail',
                name: 'Payment Fail',
                component: PaymentFailComponent,
            },
        ],
    },
];
